import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";

import Loading from "shared/components/Loading";
import Chapters from "./sections/Chapters";
import General from "./sections/General";
import Measures from "./sections/Measures";
import Publish from "./sections/Publish";
import Sidebar from "./Sidebar";
import ConfigAI from "./sections/ConfigAI";
import IntegrationForm from "components/IntegrationForm";

import "./style.scss";
import Invitation from "./sections/Invitation";
import Audit from "./sections/Audit";

const BookEdit = () => {

    const { osbn, currentSection, currentItem } = useParams();
    const { books, loading } = useSelector(state => state.books);
    const book = books[osbn];

    const sections = {
        general: <General />,
        measures: <Measures />,
        chapters: <Chapters />,
        publish: <Publish />,
    };

    const generalSubSections = {
        basic: <General />,
        template: <Invitation />,
        widget: <IntegrationForm />,
        audit: <Audit />,
        aiConfig: <ConfigAI />
    };

    return (
        <div className="container-book-edit">
            {!loading ?
                <>
                    <Sidebar book={book} />
                    <div className="edit-content">
                        {currentSection === "general" && currentItem
                            ? generalSubSections[currentItem] || <General />
                            : sections[currentSection]}
                    </div>
                </> :
                <Loading />
            }
        </div>

    );
};



export default BookEdit;